import React from 'react';
import { connect } from 'react-redux';

const Loading = props => {
  const { category, models, sets, accessories, pictures, orders } = props.loading;
  const categoryStyle = !category ? { color: '#F44336' } : {};
  const modelsStyle = !models ? { color: '#F44336' } : {};
  const setsStyle = !sets ? { color: '#F44336' } : {};
  const accessoriesStyle = !accessories ? { color: '#F44336' } : {};
  const picturesStyle = !pictures ? { color: '#F44336' } : {};
  const ordersStyle = !orders ? { color: '#F44336' } : {};
  return (
    <div style={{display: 'flex', height: '100vh', flexDirection: 'column'}}>
      <div>
        Loading...
      </div>
      <div style={categoryStyle}>CATEGORY</div>
      <div style={modelsStyle}>MODELS</div>
      <div style={setsStyle}>SETS</div>
      <div style={accessoriesStyle}>ACCESSORIES</div>
      <div style={picturesStyle}>PICTURES</div>
      <div style={ordersStyle}>ORDERS</div>
    </div>
  );
}

export default connect(
  state => {
    const { loading } = state.ui;
    return { loading };
  }
)(Loading);



// WEBPACK FOOTER //
// ./src/components/layout/content/loading.js